<template>
  <SearchForm ref="searchFormRef" :formModel="searchController.formModel" @search="tableController.search" :searchLoading="tableController.loading">
    <template #form>
      <el-form-item prop="textTitle">
        <el-input placeholder="文章标题" v-model="searchController.formModel.textTitle" clearable></el-input>
      </el-form-item>
      <el-form-item prop="textClass">
        <FetchSelect
          v-model="searchController.formModel.textClass"
          placeholder="文章分类"
          api="/web/sys/code/getSysCodeByParam"
          :postData="{ codeParam: 'SOFT_TEXT_CLASS' }"
          textKey="codeValue"
          valueKey="codeKey"
        />
      </el-form-item>
      <el-form-item prop="textType">
        <FetchSelect
          v-model="searchController.formModel.textType"
          placeholder="文章类型"
          api="/web/sys/code/getSysCodeByParam"
          :postData="{ codeParam: 'SOFT_TEXT_TYPE' }"
          textKey="codeValue"
          valueKey="codeKey"
        />
      </el-form-item>
      <el-form-item prop="textSeat">
        <FetchSelect
          v-model="searchController.formModel.textSeat"
          placeholder="文章位置"
          api="/web/sys/code/getSysCodeByParam"
          :postData="{ codeParam: 'SOFT_TEXT_SEAT' }"
          textKey="codeValue"
          valueKey="codeKey"
        />
      </el-form-item>
      <el-form-item prop="disabled">
        <el-select placeholder="状态" v-model="searchController.formModel.disabled" clearable>
          <el-option label="有效" :value="0"></el-option>
          <el-option label="无效" :value="1"></el-option>
        </el-select>
      </el-form-item>
    </template>
    <template #controll>
      <el-button type="primary" @click="clickAdd">新建</el-button>
    </template>
  </SearchForm>
  <ProTable
    :columns="tableController.columns"
    :tableData="tableController.tableData"
    :loading="tableController.loading"
    :total="tableController.total"
    :pageState="tableController.pageState"
    @pageChange="tableController.onPageChange"
  />

  <!-- 模态 -->
  <AddModal ref="addModalRef" @successAdd="tableController.search" @successEdit="tableController.refresh" />
</template>

<script>
import { ref } from 'vue'
import { ElMessage } from 'element-plus'
import SearchForm from '@/components/SearchForm'
import ProTable from '@/components/ProTable'
import AddModal from './AddModal.vue'
import FetchSelect from '@/components/FetchSelect'
import CustomLink from '@/components/customStyle/CustomLink'
import useSearchFormCtrller from '@/hooks/useSearchFormCtrller'
import useTableController from '@/hooks/useTableController'
import { actionConfirm } from '@/utils/confirm'
import request from '@/utils/request'

export default {
  setup() {
    const addModalRef = ref(null)
    // searchForm
    const searchController = useSearchFormCtrller({
      form: {
        textTitle: '',
        textClass: '',
        textType: '',
        disabled: '',
        textSeat: '',
      },
    })
    // table
    const columns = [
      { label: '文章标题', prop: 'textTitle', width: 'auto' },
      { label: '文章分类', prop: 'textClassName' },
      { label: '文章类型', prop: 'textTypeName', width: 130 },
      { label: '文章位置', prop: 'textSeatName', width: 130 },
      { label: '修改时间', prop: 'time', render: (v, record) => record.updateDateStr || record.createDateStr },
      { label: '排序', prop: 'textSeq', width: 80 },
      { label: '状态', prop: 'disabledName', width: 90 },
      {
        label: '操作',
        prop: 'actions',
        width: 100,
        render: (_, record) => {
          const statusText = record.disabled == '0' ? '失效' : '生效'
          return (
            <div>
              <CustomLink
                onClick={() => {
                  clickEdit(record)
                }}
              >
                编辑
              </CustomLink>
              <CustomLink
                onClick={() => {
                  handleToggleStatus(record)
                }}
              >
                {statusText}
              </CustomLink>
            </div>
          )
        },
      },
    ]
    const tableController = useTableController({
      columns,
      ajax: ({ page, pageSize }) => {
        const postData = {
          page,
          rows: pageSize,
          ...searchController.formModel,
        }
        return request({
          url: '/web/system/softText/getSoftTextPaging',
          data: postData,
        }).then((data) => ({ list: data.data ?? [], totalNum: data.rowTop ?? 0 }))
      },
    })

    function clickAdd() {
      addModalRef.value?.open()
    }

    function clickEdit(record) {
      addModalRef.value?.open(record)
    }

    function handleToggleStatus(record) {
      const statusText = record.disabled == '0' ? '失效' : '生效'
      actionConfirm(`确认${statusText}？`, () => {
        return request({
          url: '/web/system/softText/updateSoftTextDisabled',
          data: {
            textCode: record.textCode,
            disabled: record.disabled == '0' ? '1' : '0',
          },
        }).then(() => {
          tableController.refresh()
          ElMessage.success('操作成功')
        })
      })
    }

    return {
      searchController,
      tableController,
      //
      addModalRef,
      clickAdd,
    }
  },
  components: { SearchForm, ProTable, FetchSelect, AddModal },
}
</script>

<style></style>
